<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/accounting/Bank">
                    <icon name="file-invoice"></icon>
                    ธนาคาร
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/accounting/bank-branch">
                    <icon name="file-invoice"></icon>
                    สาขาธนาคาร
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "bank-layout"
    }
</script>

<style scoped>

</style>
